
import React from 'react';

interface SelectedUsersSummaryProps {
  selectedUsers: any[];
  onRemoveUser: (userId: string) => void;
}

const SelectedUsersSummary = ({ selectedUsers, onRemoveUser }: SelectedUsersSummaryProps) => {
  const getUserDisplayName = (user: any) => {
    return user.username || 'Unknown User';
  };

  return (
    <div className="mt-2">
      <p className="text-xs text-gray-400">
        {selectedUsers.length} member(s) selected
      </p>
      {selectedUsers.length > 0 && (
        <div className="flex flex-wrap gap-1 mt-1">
          {selectedUsers.map((user) => (
            <span
              key={user.id}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-sports-green/20 text-sports-green"
            >
              {getUserDisplayName(user)}
              <button
                type="button"
                onClick={() => onRemoveUser(user.id)}
                className="ml-1 hover:text-red-400"
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectedUsersSummary;
